import React, {Component} from 'react';
import Loader from './Loader';
import './LoadingScreen.css';

export default class LoadingScreen extends Component {
  render() {
    return(
      <div className="loading-screen">
        <Loader></Loader>
      </div>
    )
  }
}